export const randomAlphaNumeric = ({
    size = 16,
}: {
    /**
     * Number of characters to generate.
     * @default 16
     */
    size?: number;
} = {}) => {
    let result = '';
    const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    const charactersLength = characters.length;
    for (let i = 0; i < size; i++) {
        result += characters.charAt(Math.floor(Math.random() * charactersLength));
    }
    return result;
};
